import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetCourseAssignmentTeamSummariesResult = {
   teamSummaries: TeamSummary[];
   hasMore: boolean;
};

export type TeamSummary = {
   teamid: number;
   image: string;
   name: string;
   memberCount: number;
   courseCount: number;
   assignedCoursesUrl: string;
};

export type GetCourseAssignmentTeamSummariesRequestOptions = CommonRequestOptions & {
   orderby?: 'name';
   direction?: 'ASC' | 'DESC';
   page?: number;
   pageSize?: number;
   query?: string;
   hideEmptyTeams?: boolean;
};

export async function getCourseAssignmentTeamSummaries({
   orderby,
   direction,
   page,
   pageSize,
   query,
   hideEmptyTeams,
   ...common
}: GetCourseAssignmentTeamSummariesRequestOptions = {}): Promise<GetCourseAssignmentTeamSummariesResult> {
   return makeRequest('get', 'course_assignments/teamSummaries', {
      ...common,
      query: {
         orderby,
         direction,
         page,
         pageSize,
         query,
         hideEmptyTeams,
      },
   });
}
